/**
 * This file exposes frequently used meta methods.
 *
 * Since these properties are read-only, they can't easily be used in tests, and
 * unifying them in a util makes them easier to work with.
 *
 * These methods are auto-imported in components and pages and can be used
 * directly in templates, <script setup> or anywhere in the Options API without
 * having to manually import them.
 *
 * This file is ignored for coverage as import.meta is a compiler hint.
 */
/* v8 ignore start */
export const isMetaServer = Boolean(import.meta.server)
export const isMetaClient = Boolean(import.meta.client)
export const isMetaDev = Boolean(import.meta.dev)
/* v8 ignore stop */
